const TEXT_FIELD_STYLES = {
  field: {
    backgroundColor: '#f8f8f8',
    width: '100%',
    height: 52,
    paddingLeft: 16,
    borderRadius: 4,
  },
  input: {
    width: '90%',
    paddingRight: '40px',
  },
  searchIcon: {
    position: 'absolute',
    right: 16,
    top: '57px',
    pointerEvents: 'none',
  },
  dateField: {
    backgroundColor: '#f8f8f8',
    width: '100%',
    height: 52,
    paddingLeft: 16,
    borderRadius: 4,
  },
  dateInput: {
    width: '98%',
  },
  iconColor: {
    color: '#757575',
  },
}

const INCLUDE_LOCATIONS_VALUES = {
  YES: 'YES',
  NO: 'NO',
}
const STEPS = {
  FIRST: 'FIRST',
  SECOND: 'SECOND',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  PROGRESS: 'PROGRESS',
}

export { TEXT_FIELD_STYLES, INCLUDE_LOCATIONS_VALUES, STEPS }
